module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-35-84c63a82a03a56c36fd46f65da8f01d7.jpg";